import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';

import { BRUSH_SIZE, foldPresets } from '../constants';

export default function KaleidoscopeControls({
  brushSize,
  canUndo,
  folds,
  hasStroke,
  isRevealed,
  isSaving,
  onBrushSizeChange,
  onFoldChange,
  onReset,
  onReveal,
  onSave,
  onUndo,
}) {
  const t = useTranslations('common.newspaper.art_games.kaleidoscope.controls');
  const stageT = useTranslations('common.newspaper.art_games.kaleidoscope.stage');

  return (
    <aside className="kaleidoscope-controls" aria-label={t('aria.controls')}>
      <label className={`kaleidoscope-brush-size${isRevealed ? ' is-disabled' : ''}`}>
        <span>{t('brush_size')}</span>
        <input
          type="range"
          min={BRUSH_SIZE.min}
          max={BRUSH_SIZE.max}
          step={BRUSH_SIZE.step}
          value={brushSize}
          onChange={(event) => onBrushSizeChange(Number(event.target.value))}
          disabled={isRevealed}
        />
        <span
          className="kaleidoscope-brush-size__preview"
          style={{ height: `${brushSize}px` }}
          aria-hidden="true"
        />
      </label>
      <div className="kaleidoscope-folds" role="group" aria-label={stageT('aria.fold_presets')}>
        {foldPresets.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className={`kaleidoscope-folds__button ${folds === preset.value ? 'is-active' : ''}`}
            onClick={() => onFoldChange(preset.value)}
            disabled={preset.value === folds}
            aria-pressed={folds === preset.value}
          >
            {stageT(preset.labelKey)}
          </button>
        ))}
      </div>
      <div className="kaleidoscope-actions">
        {isRevealed ? (
          <>
            <ContinueButton type="button" onClick={onReset}>
              {t('actions.new_drawing')}
            </ContinueButton>
            <ContinueButton type="button" onClick={onSave} loading={isSaving}>
              {isSaving ? t('actions.saving') : t('actions.save')}
            </ContinueButton>
          </>
        ) : (
          <>
            <ContinueButton type="button" onClick={onUndo} disabled={!canUndo}>
              {t('actions.undo')}
            </ContinueButton>
            <ContinueButton type="button" onClick={onReveal} disabled={!hasStroke}>
              {t('actions.reveal')}
            </ContinueButton>
          </>
        )}
      </div>
    </aside>
  );
}
